/**
 * Wrap your scripts within an IIFE or a DOMContentLoaded eventlistener.
 *
 * This will scope our scripts to prevent potential conflicts between
 * our custom work and the main theme stylesheet.
 */

document.addEventListener('DOMContentLoaded', function () {
  // Custom scripts go here...

  const accordion = {
    accordionQuestions: document.querySelectorAll('.accordion-container'),

    closeAccordion: function() {
      accordion.accordionQuestions.forEach((question) => {
        question.classList.remove('active');
      })          
    },
    accordionLogic: function() {
      for (i=0; i<accordion.accordionQuestions.length; i++) {

        accordion.accordionQuestions[i].addEventListener('click', function () {

          accordion.accordionQuestions.forEach((question) => {

            if(!this.classList.contains('active')){
              question.classList.remove('active')  
            } 

          })
          this.classList.toggle('active') 

        })    
      }
    }
  }

  accordion.accordionLogic()
})